import PublicNav from "../Components/PublicNav";
import Footer from "../Components/Footer";

const VALUES = [
  {
    title: "Simplicity",
    desc: "No bloated dashboards. Just the insights that matter, surfaced instantly.",
  },
  {
    title: "Transparency",
    desc: "You own your data. We never sell it, share it, or use it to train AI models.",
  },
  {
    title: "Reliability",
    desc: "Built to scale with your business — from one location to dozens.",
  },
];

function AboutPage() {
  return (
    <div className="lp-page">
      <PublicNav />

      <section className="ip-hero">
        <div className="ip-hero-inner">
          <div className="lp-section-label">About</div>
          <h1 className="ip-hero-title">Built for businesses that take reputation seriously</h1>
          <p className="ip-hero-sub">
            RIRA was created because every business deserves the same review intelligence tools that enterprise brands rely on — without the enterprise price tag.
          </p>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner">
          <h2 className="ip-section-title">Our Mission</h2>
          <p className="ip-body">
            Customer reviews are one of the most powerful forces shaping a business's reputation. Yet most small and medium businesses lack the tools to monitor, analyze, and respond to them effectively. RIRA changes that.
          </p>
          <p className="ip-body">
            We connect directly to your Google Business Profile and turn raw reviews into actionable intelligence — AI-powered insights, sentiment breakdowns, competitor comparisons, and smart reply drafts — so you can respond faster, improve continuously, and grow with confidence.
          </p>
        </div>
      </section>

      <section className="ip-section ip-section--alt">
        <div className="ip-section-inner">
          <h2 className="ip-section-title">Our Values</h2>
          <div className="ip-cards">
            {VALUES.map((v) => (
              <div key={v.title} className="ip-card">
                <h3 className="ip-card-title">{v.title}</h3>
                <p className="ip-card-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner">
          <h2 className="ip-section-title">Who we are</h2>
          <p className="ip-body">
            RIRA is an independent SaaS product built to empower small and medium business owners in the age of AI. We are a small, passionate team who believe that local businesses deserve every competitive advantage available.
          </p>
          <p className="ip-body">
            Have a question or feedback? We would love to hear from you — reach us at{" "}
            <a className="ip-link" href="mailto:rirareview@gmail.com">rirareview@gmail.com</a>.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutPage;
